<template>
  <div
    v-bind:class="'checkbox check-' + type"
    style="margin-right: auto; margin-left: auto"
  >
    <input type="checkbox" v-bind:value="val" v-bind:id="id" />
    <label v-bind:for="id">{{ label }}</label>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
    },

    type: {
      type: String,
      default: "default",
    },
    val: String,
    label: String,
  },
};
</script>

<style scoped>
</style>
